import React, { useState, useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

const VUOTO = { costo_giornaliero: "", km: "", litri: "", costo_litro: "", importo: "", descrizione: "" };
const CAMPI = [
  { k: "costo_giornaliero", label: "Importo noleggio (€/giorno)", step: "0.01", hint: "solo righe Noleggio" },
  { k: "km", label: "Km percorsi", step: "1", hint: "solo righe Carburante" },
  { k: "litri", label: "Litri", step: "0.01", hint: "solo righe Carburante" },
  { k: "costo_litro", label: "€/litro", step: "0.001", hint: "solo righe Carburante" },
  { k: "importo", label: "Pedaggio (€)", step: "0.01", hint: "solo righe Pedaggio" },
];

export function ModificaVeicoliBulk({ open, ids, onClose, onSaved }) {
  const [f, setF] = useState(VUOTO);
  useEffect(() => { if (open) setF(VUOTO); }, [open]);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const mut = useMutation({
    mutationFn: async (p) => (await api.put("/veicoli-costi-bulk", p)).data,
    onSuccess: (r) => { toast.success(`${r.aggiornate} righe aggiornate`); onSaved(); },
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });

  const salva = () => {
    const p = { ids };
    for (const c of CAMPI) if (f[c.k] !== "") p[c.k] = Number(f[c.k]);
    if (f.descrizione.trim() !== "") p.descrizione = f.descrizione.trim();
    if (Object.keys(p).length === 1) return toast.error("Compila almeno un campo da modificare");
    mut.mutate(p);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="bulk-vei-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Modifica {ids.length} righe selezionate</DialogTitle>
          <DialogDescription>Compila solo i campi da cambiare: quelli lasciati vuoti non verranno modificati. Ogni campo si applica solo alle righe del tipo indicato.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {CAMPI.map((c) => (
            <div key={c.k} className="space-y-1.5">
              <Label>{c.label}</Label>
              <div className="text-xs text-slate-400 -mt-1">{c.hint}</div>
              <Input type="number" min="0" step={c.step} placeholder="Non modificare" value={f[c.k]} onChange={set(c.k)} data-testid={`bulk-vei-${c.k}`} />
            </div>
          ))}
          <div className="space-y-1.5 col-span-2">
            <Label>Descrizione</Label>
            <Input placeholder="Non modificare" value={f.descrizione} onChange={set("descrizione")} data-testid="bulk-vei-descrizione" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="bulk-vei-annulla">Annulla</Button>
          <Button onClick={salva} disabled={mut.isPending} data-testid="bulk-vei-salva">{mut.isPending ? "Salvataggio…" : "Applica a tutte"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
